<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card class="overflow-hidden">
            <div slot="no-body">
            <div class="p-3 pb-5" :class="{'flex justify-between flex-row-reverse items-center': iconRight}">
                <div class="vx-row">
                    <div class="vx-col" style="padding-right:10px;padding-top: 7px;">
                <feather-icon :icon="icon" class="p-3 inline-flex rounded-full" :class="[`text-${color}`, {'mb-4': !iconRight}]" :style="{background: `rgba(var(--vs-${color}),.15)`}"></feather-icon>
                    </div>
                    <div class="vx-col">
                    <h2 class="mb-1 font-bold" style="text-align:right;margin-top:10px" >{{ statistic }}</h2>
                    </div>
                    </div>
                     <div class="vx-row">
                          <div class="vx-col">
                    <p style="font-size: 13px;margin-left: 15px;">{{ statisticTitle }}</p>
                    </div>
                    </div>
                </div>
                
            </div>

    </vx-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default{
    props: {
        icon: {
            type: String,
            required: true
        },
        statistic: {
            type: [Number, String],
            required: true,
        },
        statisticTitle: {
            type: String,
        },
        chartData: {
            type: Array,
            required: false
        },
        color: {
            type: String,
            default: 'primary',
        },
        chartType: {
            type: String,
            default: 'line-chart',
        },
        type: {
            type: String,
            default: 'line'
        },
        iconRight: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        themePrimaryColor() {
            this.$refs.apexChart.updateOptions({ theme: { monochrome: { color: this.getHex() } } });
        }
    },
    computed: {
        themePrimaryColor() {
            return this.$store.state.themePrimaryColor;
        }
    },
    methods: {
        getHex() {
            let rgb  = window.getComputedStyle(document.documentElement).getPropertyValue(`--vs-${this.color}`);
            rgb = rgb.split(",");
            return "#" + ((1 << 24) + (Number(rgb[0]) << 16) + (Number(rgb[1]) << 8) + Number(rgb[2])).toString(16).slice(1);
        },
    },
    components: {
        VueApexCharts
    },
 
}
</script>